import * as constants from '../../constants/CONSTANT';
import jwt_decode from 'jwt-decode';

const adminAuthApi = {
  async login(email, password) {
    const response = await fetch(constants.API_BASE_URL + '/api/admin/login', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const result = await response.json();
    if (result.success) {
      localStorage.setItem('adminToken', result.authToken);
      try {
        jwt_decode(result.authToken);
      } catch (error) {
        // ignore token decode errors
      }
      if (result.authSettings) {
        localStorage.setItem(
          'adminAuthSettings',
          JSON.stringify(result.authSettings)
        );
      }
    }

    return result;
  },

  logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminAuthSettings');
  },
};

export default adminAuthApi;
